import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DashboardWidgetGrid } from '../dashboard-widget-base/dashboard-widget-base.component';
import { DashboardService } from '../dashboard.service';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { Grid } from '@app/core/components/grid/grid.model';

@Component({
    selector: 'tt-dashboard-widget-grid',
    templateUrl: './dashboard-widget-grid.component.html',
    styleUrls: ['./dashboard-widget-grid.component.css'],
})
export class DashboardWidgetGridComponent implements OnChanges {
    @Input()
    public ttDashboardWidget?: DashboardWidgetGrid;

    private slicerData: any;

    grid?: GridOptions;

    constructor(private dashboard: DashboardService) {}

    private createGrid() {
        if (!this.grid && !!this.ttDashboardWidget?.p2_datatask_keyno && '' + this.ttDashboardWidget?.p2_datatask_keyno !== '0') {
            if (this.ttDashboardWidget.kpislicers)
                this.ttDashboardWidget.slicersChanged().subscribe({
                    next: (value) => {
                        this.slicerData = value;
                    },
                });

            this.grid = new Grid()
                .setRememberId(this.getRememberId())
                .setLoadDataFunction({ method: this.ttDashboardWidget.p2_datatask_keyno, parameters: () => ({ ...this.getDashboardContextParams(), slicerdata: this.slicerData }) });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private getRememberId(): string {
        const dashboardName = this.ttDashboardWidget?.dashboardName;
        const context = this.ttDashboardWidget?.dashboardContext;
        const kpiCompKeyno = this.ttDashboardWidget?.kpicomp_keyno;

        if (!!dashboardName && context?.argtype === 'webpage_name' && '' + context.argvalue === dashboardName) {
            return 'dashboard.widget.grid.' + kpiCompKeyno;
        }

        if (!!dashboardName && !!context) {
            return 'dashboard.widget.grid.' + dashboardName + '.' + this.dashboard.getDashboardContextKey(context) + '.' + kpiCompKeyno;
        }

        return 'dashboard.widget.grid.' + kpiCompKeyno;
    }

    private getDashboardContextParams() {
        return this.ttDashboardWidget?.dashboardContext ? { ...this.ttDashboardWidget.dashboardContext } : {};
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['ttDashboardWidget']) {
            this.createGrid();
        }
    }
}
